import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {PermissionService} from "@services/permission.service";
import {FCMService} from "@services/fcm.service";
import {environment} from "@env";
import {SwUpdate} from "@angular/service-worker";
import {AppUpdateService} from "@services/app-update.service";
import {MessageService} from "primeng/api";
import {SpinnerService} from "@services/spinner.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'Maedah Admin';

  constructor(private router: Router,
              private permissionsService: PermissionService,
              private fcmService: FCMService,
              private swUpdate: SwUpdate,
              private appUpdateService: AppUpdateService,
              private messageService: MessageService,
              public spinnerService: SpinnerService,
              ) {
    this.permissionsService.loadPermissions();
  }

  ngOnInit() {
    this.fcmService.requestPermission();
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    if (this.swUpdate.isEnabled) {
      this.appUpdateService.updateChecker().subscribe(() => {
        this.appUpdateService.availableStatus.next(true);
        // Show PrimeNG toast notification instead of NbWindow dialog
        this.messageService.add({
          severity: 'info',
          summary: 'Update Available',
          detail: 'A new version of Maedah Admin is available. Please refresh the page.',
          life: 10000,
          closable: true
        });
      });
    }

    const style = 'color:#2f6fbd; padding: 10px 20px; font-size: 20px; font-family: Courier New;';
    const rainbowStyle = 'font-weight: bold; font-size: 50px; color: #c7931d; font-family: Courier New;';
    console.log('%cMaedah', rainbowStyle);
    console.log(`%cMaedah \nUpdated ${environment.updated_at} \nVersion ${environment.version}+${environment.build}`, style);
  }
}
